import { FormTextField } from "../../wsui/form";
import kebabCase from "lodash/kebabCase";
import React from "react";

export default function FormModuleMessageField({
  field: { label, description, required },
  rows = 4,
  ...restProps
}) {
  return (
    <FormTextField
      description={description}
      label={label}
      name={kebabCase(label)}
      required={required}
      rows={rows}
      // className={required && styles.required}
      {...restProps}
    />
  );
}
